import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-05_01",
  version: "2026.06.05",
  date: "5 Jun 2026",
  sinceCommit: "ad9a51d",
  gameplay: [
    { text: "Shop economy: spells now cost Skill Points instead of gold; gold is for items only. +1 SP after each round." },
    { text: "Facing turn rate doubled (7 → 14 rad/s)." },
    { text: "Disconnected players automatically walk back toward safety when knocked toward the void." },
  ],
  skills: [
    {
      spellId: "fireball",
      changes: [
        { passiveId: "fireball_damage", text: "New passive **Heavier Hit**: +25% damage." },
        { passiveId: "fireball_knockback", text: "New passive **Launch Force**: +30% knockback." },
        { passiveId: "fireball_speed", text: "New passive **Swift Bolt**: +20% projectile speed." },
        { passiveId: "fireball_cooldown", text: "New passive **Quick Cast**: −12% cooldown." },
      ],
    },
    {
      spellId: "blizzard",
      changes: [
        { passiveId: "blizzard_radius", text: "New passive **Wider Front**: +25% zone radius." },
        { passiveId: "blizzard_damage", text: "New passive **Rime Shards**: +20% tick damage." },
        { passiveId: "blizzard_cooldown", text: "New passive **Cold Focus**: −15% cooldown." },
        {
          passiveId: "blizzard_meteor_shower",
          text: "New synergy (pairs with Meteor): rain embers instead of ice — higher damage, burn, and slow.",
        },
      ],
    },
    {
      spellId: "meteor",
      changes: [
        { passiveId: "meteor_damage", text: "New passive **Heavier Impact**: +25% blast damage." },
        { passiveId: "meteor_cooldown", text: "New passive **Quick Call**: −12% cooldown." },
        {
          passiveId: "meteor_nuke",
          text: "New synergy (pairs with Fireball): impact unleashes fireballs in all directions.",
        },
      ],
    },
    {
      spellId: "scourge",
      changes: [
        { passiveId: "scourge_damage", text: "New passive **Volatile Core**: +25% blast damage." },
        { passiveId: "scourge_knockback", text: "New passive **Shockwave**: +30% knockback." },
      ],
    },
    {
      spellId: "icelance",
      changes: [{
        text: "Glacier Spear renamed to **Ice Lance** (slot 1 projectile).",
      }],
    },
    {
      spellId: "glacier",
      changes: [{
        text: "New spell (slot W): raise a solid ice wall crossways to your aim — blocks movement and projectiles; only Teleport crosses.",
      }],
    },
  ],
};
